import React from 'react';
import styles from './progress.module.styl';
import { SvgIconReact } from './index';
const PROGRESS_CIRCLE_RADIUS = 8;
type ExperimentStatusProps = {
  percent: number;
};
export function ProgressIcon(_ref: ExperimentStatusProps) {
  let {
    percent
  }: ExperimentStatusProps = _ref;
  return <div className={styles.progressIcon} data-sentry-component="ProgressIcon" data-sentry-source-file="progress.tsx">
      <SvgIconReact icon='circle' data-sentry-element="SvgIconReact" data-sentry-source-file="progress.tsx" />
      <SvgIconReact className={styles.progress} style={{
      strokeDashoffset: -1.5 * PROGRESS_CIRCLE_RADIUS * Math.PI,
      strokeDasharray: "".concat(2 * percent * PROGRESS_CIRCLE_RADIUS * Math.PI, " ").concat(2 * (1 - percent) * PROGRESS_CIRCLE_RADIUS * Math.PI)
    }} icon='circle' data-sentry-element="SvgIconReact" data-sentry-source-file="progress.tsx" />
    </div>;
}